import gql from "graphql-tag"

export const CHECKOUT_USER_ERROR_FRAGMENT = gql`
  fragment CheckoutUserErrorFragment on CheckoutUserError {
    field
    message
    code
  }
`
